const CustomerClosedTickets = () =>
  import("@/views/serviceticket/CustomerClosedTickets.vue");
const CustomerClosedTicketView = () =>
  import("@/views/serviceticket/CustomerClosedTicketView.vue");
const CustomerOpenTickets = () =>
  import("@/views/serviceticket/CustomerOpenTickets.vue");
const CustomerTicketEdit = () =>
  import("@/views/serviceticket/CustomerTicketEdit.vue");

export default {
  path: "serviceticket",
  meta: {
    label: "Service Ticket",
  },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "close",
      name: "close-service-ticket",
      meta: {
        label: "Close Servive Ticket",
        requiresAuth: true,
      },
      component: CustomerClosedTickets,
    },
    {
      path: "open",
      name: "open-service-ticket",
      meta: {
        label: "Open Service Ticket",
        requiresAuth: true,
      },
      component: CustomerOpenTickets,
    },
    {
      path: "view/:id",
      name: "view-service-ticket ",
      meta: {
        label: "View Service Ticket",
        requiresAuth: true,
      },
      component: CustomerClosedTicketView,
    },
    {
      path: "edit/:id",
      name: "edit-service-ticket",
      meta: {
        label: "Edit Service Ticket",
        requiresAuth: true,
      },
      component: CustomerTicketEdit,
    },
  ],
};
